export default "__VITE_ASSET__ded3dc4e__"